import { SchemaType } from '../type';
export const schema = {
    id: 'ai_project_info',
    name: 'AI页面代码',
    type: SchemaType.Indivisible,
};
